import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ProfileSearchResult} from '../../data/ProfileSearchResult';

@Component({
  selector: 'app-cardholder-details',
  templateUrl: './cardholder-details.component.html',
  styleUrls: ['./cardholder-details.component.css']
})
export class CardholderDetailsComponent implements OnInit {

  @Output() newCardholderSelected: EventEmitter<ProfileSearchResult> = new EventEmitter();
  @Input() cardholder: ProfileSearchResult;

  constructor() { }

  ngOnInit() {

  }

  newCardholder(newCardholder: ProfileSearchResult) {
    this.newCardholderSelected.emit(newCardholder);
  }

}
